import { qualifyUrl } from "util/URLUtils";
import fetch from "logic/rest/FetchProvider";
import { LookupTablesActions, LookupTablesStore } from "stores/lookup-tables/LookupTablesStore";
import {
  LookupTableDataAdaptersActions,
  LookupTableDataAdaptersStore
} from "stores/lookup-tables/LookupTableDataAdaptersStore";
import { LookupTableCachesActions, LookupTableCachesStore } from "stores/lookup-tables/LookupTableCachesStore";
import deserializeLookupTables from "components/lookup-tables/lookup-table-list/utils";
import deserializeCaches from "components/lookup-tables/cache-list/utils";
import deserializeDataAdapters from "components/lookup-tables/adapter-list/utils";
export const deleteLookupTable = async (tableId) => LookupTablesActions.delete(tableId);
export const fetchErrors = async ({
  lutNames = void 0,
  cacheNames = void 0,
  adapterNames = void 0
}) => LookupTablesActions.getErrors(lutNames, cacheNames, adapterNames);
export const fetchPaginatedLookupTables = async (searchParams) => {
  const { page, pageSize, query, sort } = searchParams;
  const sortField = sort == null ? void 0 : sort.attributeId;
  const sortOrder = sort == null ? void 0 : sort.direction;
  const promise = LookupTablesStore.searchPaginated(page, pageSize, query, true, sortField, sortOrder);
  LookupTablesActions.searchPaginated.promise(promise);
  return promise.then(deserializeLookupTables);
};
export const fetchLookupTable = async (idOrName) => LookupTablesActions.get(idOrName);
export const createLookupTable = async (payload) => LookupTablesActions.create(payload);
export const updateLookupTable = async (payload) => LookupTablesActions.update(payload);
export const purgeLookupTableKey = async ({ table, key }) => LookupTablesActions.purgeKey(table, key);
export const purgeAllLookupTableKey = async (table) => LookupTablesActions.purgeAll(table);
export const testLookupTableKey = async ({ tableName, key }) => LookupTablesActions.lookup(tableName, key);
export const fetchLookupPreview = async (idOrName, size) => fetch("GET", qualifyUrl(`/system/lookup/tables/preview/${idOrName}?size=${size}`));
export const fetchPaginatedCaches = async (searchParams) => {
  const { page, pageSize, query, sort } = searchParams;
  const sortField = sort == null ? void 0 : sort.attributeId;
  const sortOrder = sort == null ? void 0 : sort.direction;
  const promise = LookupTableCachesStore.searchPaginated(page, pageSize, query, sortField, sortOrder);
  LookupTableCachesActions.searchPaginated.promise(promise);
  return promise.then(deserializeCaches);
};
export const fetchCache = async (idOrName) => LookupTableCachesActions.get(idOrName);
export const fetchCacheTypes = async () => {
  await LookupTableCachesActions.getTypes();
  const state = LookupTableCachesStore.getInitialState();
  return state.types;
};
export const validateCache = async (cache) => LookupTableCachesActions.validate(cache);
export const createCache = async (payload) => LookupTableCachesActions.create(payload);
export const updateCache = async (payload) => LookupTableCachesActions.update(payload);
export const deleteCache = async (cacheId) => LookupTableCachesActions.delete(cacheId);
export const fetchPaginatedDataAdapters = async (searchParams) => {
  const { page, pageSize, query, sort } = searchParams;
  const sortField = sort == null ? void 0 : sort.attributeId;
  const sortOrder = sort == null ? void 0 : sort.direction;
  const promise = LookupTableDataAdaptersStore.searchPaginated(page, pageSize, query, sortField, sortOrder);
  LookupTableDataAdaptersActions.searchPaginated.promise(promise);
  return promise.then(deserializeDataAdapters);
};
export const fetchDataAdapter = async (idOrName) => LookupTableDataAdaptersActions.get(idOrName);
export const fetchDataAdapterTypes = async () => {
  await LookupTableDataAdaptersActions.getTypes();
  const state = LookupTableDataAdaptersStore.getInitialState();
  return state.types;
};
export const createDataAdapter = async (payload) => LookupTableDataAdaptersActions.create(payload);
export const updateDataAdapter = async (payload) => LookupTableDataAdaptersActions.update(payload);
export const validateDataAdapter = async (adapter) => LookupTableDataAdaptersActions.validate(adapter);
export const deleteDataAdapter = async (adapterId) => LookupTableDataAdaptersActions.delete(adapterId);
